import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


export const constantRoutes = [
    {
        path: '/',
        component: () => import('@/views/index/index'),
    },
    {
        path: '/business',
        component: () => import('@/views/business/index'),
    },
    {
        path: '/about',
        component: () => import('@/views/about/index'),
    },

    {
        path: '/solution',
        component: () => import('@/views/solution/index'),
    },
    {
        path: '/product',
        component: () => import('@/views/product/index'),
    },

]

const createRouter = () => new Router({
    routes: constantRoutes
})

const router = createRouter()

export default router
